import { useEffect, useReducer, useRef, useState } from 'react';
import { useScreenshot } from 'use-react-screenshot';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getFileExtFromBase64 } from '../../../../../../utility/utility';
import socketService from '../../../../../../services/socket.service';
import { setCallMessages } from '../../../../../../redux/chats_messages/actions';
const useCallPanel = () => {
  const mediaElementRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const screenshotRef = useRef(null);
  const [newCallMessages, setNewCallMessages] = useState(0);
  const [image, takeScreenshot] = useScreenshot();
  const { callMessages } = useSelector((state) => state.chatsMessages);
  const reduxDispatch = useDispatch();
  const initialState = {
    dataStream: [],
    recording: false,
    videoFile: null,
    imageFile: image,
    isCaptured: false,
  };

  useEffect(() => {
    socketService.on('call_message', (res) => {
      setNewCallMessages(newCallMessages + 1);
      reduxDispatch(
        setCallMessages([
          ...callMessages,
          { text: res?.message, sender: res?.user, createdAt: new Date().toISOString() },
        ]),
      );
    });
  }, [callMessages]);
  const [state, dispatch] = useReducer((newState, value) => ({ ...newState, ...value }), initialState);

  const { recording, isCaptured } = state;
  const onStartScreenRecording = async () => {
    const audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
    navigator.mediaDevices
      .getDisplayMedia({
        video: {
          chromeMediaSource: 'screen',
          mediaSource: 'screen',
        },
        audio: true,
      })
      .then((stream) => {
        const chunks = [];

        let mediaStream;
        if (!audioStream || audioStream === 'unavailable') {
          mediaStream = stream;
        } else {
          mediaStream = new MediaStream([...stream.getVideoTracks(), ...audioStream.getAudioTracks()]);
        }

        const mediaRecorder = new MediaRecorder(mediaStream);
        mediaRecorderRef.current = mediaRecorder;

        mediaRecorder.ondataavailable = (e) => {
          chunks.push(e.data);
          dispatch({ dataStream: [e.data] });
        };

        mediaRecorder.start();
        mediaRecorder.onstart = () => {
          dispatch({ recording: true });
        };

        mediaRecorder.onstop = () => {
          dispatch({ recording: false });
          mediaStream.getTracks().forEach((track) => track.stop());
          const blob = new Blob(chunks, { type: 'video/webm' });
          dispatch({ videoFile: blob });
          dispatch({ isCaptured: true });
        };
      });
  };
  const handleStopRecording = () => {
    mediaRecorderRef.current.stop();
    dispatch({ isCaptured: true });
  };

  const handleScreenshot = () => {
    const appLayout = document.querySelector('#app-layout');
    takeScreenshot(appLayout)
      .then((result) => {
        dispatch({ imageFile: result });
        message.success('Screen shot captured!', [10]);
        dispatch({ isCaptured: true });
      })
      .catch((error) => message.error(error.message, [10]));
  };

  const downloadScreenshot = () => {
    const fileExt = getFileExtFromBase64(state.imageFile);
    const time = new Date().toISOString();
    const fileName = `dicomx-screenshot-${time}.${fileExt}`;
    const link = document.createElement('a');
    link.href = state.imageFile;
    link.download = fileName;
    link.click();
    dispatch({ imageFile: null });
    dispatch({ isCaptured: false });
  };

  const removeFile = () => {
    dispatch({ videoFile: null });
    dispatch({ imageFile: null });
    dispatch({ isCaptured: false });
  };
  return {
    state,
    onStartScreenRecording,
    mediaElementRef,
    removeFile,
    handleStopRecording,
    handleScreenshot,
    screenshotRef,
    downloadScreenshot,
    recording,
    isCaptured,
    newCallMessages,
    setNewCallMessages,
  };
};

export default useCallPanel;
